import { makeStyles } from '@mui/styles';

const styles = makeStyles(theme => ({
  cardContainer: {
    '@media print': {
      width: '100mm',
      height: '50mm',
      boxSizing: 'border-box',
    },
  }
}));
export default styles;